import { getLocale } from "../runtime";

const sv_notifyformemailsuccess = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Perfekt! Vi hör av oss så fort produkten är tillbaka.`
};

const notifyformemailsuccess = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_notifyformemailsuccess(inputs)
	return "notifyFormEmailSuccess";
};

export { notifyformemailsuccess as "notifyFormEmailSuccess" };